import styled, { css } from 'styled-components';

import DropZone from 'react-dropzone';
import { SvgFileUpload } from '../Svg/Svg';

/* eslint-disable no-confusing-arrow */

export const Plus = styled.div`
  background-image: url(${p => p.svg});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 20px;
  width: 20px;
`;

export const Text = styled.p`
  color: ${p => p.theme.color.graySemiDark};
  font-size: 14px;
  font-weight: ${p => p.theme.fontSemibold};
  margin: 5px 0 0;
  text-align: center;
`;

export const SCDropZone = styled(DropZone)`
  align-items: center;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 50%;
  justify-content: center;
  width: 100%;

  & span {
    text-align: center;

    & button {
      margin-top: 15px;
    }
  }

  ${p =>
    p.rejected &&
    css`
      border: 1px solid ${p.theme.color.red};
      box-shadow: 0 0 3px ${p.theme.color.red};
    `};
`;

export const CloseCircle = styled.div`
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background: url(${p => p.svg});
  border-radius: 50%;
  box-shadow: ${p => p.theme.boxShadow1};
  height: 30px;
  position: absolute;
  right -10px;
  top: -10px;
  width: 30px;
  z-index: 10;
`;

export const DocumentName = styled.p`
  margin: 0;
  padding: ${p => p.theme.base.spacing.regular} 0px 0px 0px;
  word-wrap: break-word;

  ${p =>
    p.status === 2 &&
    css`
      ${p.small &&
        css`
          margin-top: 100px;

          @media (${p.theme.mq.mobile}) {
            margin-top: 75px;
          }
        `};
    `};
`;

export const TextContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
`;

export const DownloadContainer = styled.div`
  align-items: center;
  cursor: pointer;
  display: ${p => (p.uploaded ? 'none' : 'flex')};
  flex-direction: column;
  height: 50%;
  justify-content: center;
  text-align: center;
  width: 100%;
`;

export const DropZoneIcon = styled(SvgFileUpload)`
  display: inline-block;
  height: 64px;
  margin: 0 auto;
  width: 64px;
`;

export const SpinnerOverlay = styled.div`
  align-items: center;
  background-color: ${p => p.theme.rgba('white', 0.5)};
  display: flex;
  height: 400px;
  justify-content: center;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 5;

  @media (${p => p.theme.mq.mobile}) {
    height: 300px;
    width: 240px;
  }

  ${p =>
    p.small &&
    css`
      height: 200px;
      width: 160px;

      @media (${p.theme.mq.mobile}) {
        height: 150px;
        width: 120px;
      }
    `};
`;

export const File = styled.div`
  background-image: url(${p => (p.uploaded ? p.svg : null)});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 200px;
  margin-bottom: 80px;
  margin-right: ${p => p.theme.base.spacing.large};
  position: relative;
  width: 160px;

  ${Plus}, ${Text} {
    display: none;
  }

  ${p =>
    !p.isUploading &&
    css`
      &:hover {
        background-image: url(${p.svghover});

        ${Text} {
          display: inline-block;
          color: ${p.theme.color.whiteTrue};
        }

        ${Plus} {
          display: inline-block;
          background-image: url(${p.plussignwhite});
        }

        ${DownloadContainer}, ${SCDropZone} {
          background-color: ${p.theme.rgba('black', 0.2)};
        }

        ${DownloadContainer}:hover, ${SCDropZone}:hover {
          background-color: ${p.theme.rgba('black', 0.4)};

          ${Text}, ${Plus} {
            color: ${p.theme.color.whiteTrue};
            display: inline-block;
          }
        }
      }
    `};

  ${p =>
    p.rejected &&
    css`
      border: 1px solid ${p.theme.color.red};
      box-shadow: 0 0 3px ${p.theme.color.red};
    `};

  @media (${p => p.theme.mq.mobile}) {
    height: 150px;
    width: 120px;
    background: url(${p => p.svghover});

    ${Text} {
      display: inline-block;
      color: ${p => p.theme.color.whiteTrue};
    }

    ${Plus} {
      display: inline-block;
      background-image: url(${p => p.plussignwhite});
    }
  }
`;

export const FileUploadLarge = styled.div`
  background-image: url(${p => (p.uploaded ? p.svg : null)});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border: 2px dashed ${p => p.theme.color.gray};
  border-radius: 3px;
  height: 400px;
  position: relative;
  width: 100%;

  @media (${p => p.theme.mq.mobile}) {
    height: 300px;
  }

  ${SCDropZone} {
    height: 100%;
    width: 100%;
  }

  ${p =>
    p.rejected &&
    css`
      border: 1px solid ${p.theme.color.red};
      box-shadow: 0 0 3px ${p.theme.color.red};
    `};
  }
`;

export const FileUpload = styled.div`
  background-image: url(${p => (p.uploaded ? p.svg : null)});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border: 2px dashed ${p => p.theme.color.gray};
  border-radius: 3px;
  height: 200px;
  margin-bottom: 80px;
  margin-right: ${p => p.theme.base.spacing.large};
  position: relative;
  width: 160px;

  @media (${p => p.theme.mq.mobile}) {
    height: 150px;
    width: 120px;
  }

  ${SCDropZone} {
    height: 100%;
    width: 100%;
  }

  ${Text} {
    height: auto;
  }

  ${p =>
    p.rejected &&
    css`
      border: 1px solid ${p.theme.color.red};
      box-shadow: 0 0 3px ${p.theme.color.red};
    `};
`;

/* eslint-enable no-confusing-arrow */



// WEBPACK FOOTER //
// ./src/components/FileUploader/styles.js